import { render } from "./ViewContact.vue?vue&type=template&id=d5673f14&scoped=true"
import script from "./ViewContact.vue?vue&type=script&lang=js"
export * from "./ViewContact.vue?vue&type=script&lang=js"

import "./ViewContact.vue?vue&type=style&index=0&id=d5673f14&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2221027770/src/vedicastrologyreport-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5673f14"]])

export default __exports__